import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';
import {isFirstLoad} from 'nutshell-core/utils/graphql-loading';

import type {
    GetTasksForPeep as GetTasksForPeepQuery,
    GetTasksForPeep_peep_tasks as Tasks,
    GetTasksForPeepVariables,
} from 'nutshell-graphql-types';

import GET_TASKS_FOR_PEEP from '../queries/get-tasks-for-peep.graphql';

export const useGetTasksForPeep = (
    peepId: string
): {
    tasks: Tasks[] | null | undefined;
    isLoading: boolean;
    isFirstLoad: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch, networkStatus} = useQuery<
        GetTasksForPeepQuery,
        GetTasksForPeepVariables
    >(GET_TASKS_FOR_PEEP, {
        variables: {
            peepId,
        },
        fetchPolicy: 'cache-and-network',
    });

    return {
        tasks: data && data.peep && data.peep.tasks,
        isLoading: loading,
        isFirstLoad: isFirstLoad(networkStatus),
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
